import {getLanguages, getLocale} from "../utils";
import {useState} from "react";

const LangSwitcher = (props) => {
  const languages = getLanguages();
  const locale = getLocale();
  const currentLang = languages.find(lang => lang.locale === locale);

  const setLang = (lang) => {
    localStorage.setItem('locale', lang.locale);
    localStorage.setItem('dir', lang.direction);
    window.location.reload();
  }

  return (
    <div className={'text-white flex items-center cursor-pointer'}>
      {
        languages.map((lang, index) => (
          <>
            <div className={'flex gap-x-1 items-center'} key={index} onClick={() => setLang(lang)}>
              <h5 className={`${locale === lang.locale ? 'text-red-500' : ''}`}>{lang.label}</h5>
              <img className={'w-6 h-6'} src={lang.image} alt=""/>
            </div>
            {
              index !== languages.length - 1 &&
              <span>|</span>
            }
          </>
        ))
      }
    </div>
  )
}

export default LangSwitcher